import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function CustomerAccountForm() {
  const [user, setUser] = useState({
    userId: "",
    UserEmail: "",
    UserName: "",
    UserMobile: "",
    UserFirstName: "",
    UserLastName: "",
  });

  // Get user data from Redux (set by NavBar/HomePage via setCatalystUser action)
  const UserData = useSelector((state) => state.SingIn?.SingIn);
  console.log("this is user data", UserData);

  useEffect(() => {
    if (UserData) {
      // Case 1: Old structure (from customerLogin / Google login)
      if (UserData.data || UserData.user) {
        const customer = UserData?.data?.customerRes?.[0] || {};
        const userInfo = UserData?.user || {};

        setUser({
          userId: userInfo.ROWID || customer.ROWID || "",
          UserEmail: userInfo.email || customer.email || "",
          UserMobile: userInfo.phone || customer.phone || "",
          UserFirstName: userInfo.firstName || customer.firstName || "",
          UserLastName: userInfo.lastName || customer.lastName || "",
          UserName: `${userInfo.firstName || customer.firstName || ""} ${
            userInfo.lastName || customer.lastName || ""
          }`.trim(),
        });
      } 
      // Case 2: New Catalyst user structure (from setCatalystUser)
      else if (UserData.firstName !== undefined || UserData.email !== undefined) {
        const firstName = UserData.firstName || "";
        const lastName = UserData.lastName || "";
        setUser({
          userId: UserData.userId || "",
          UserEmail: UserData.email || "",
          UserMobile: UserData.mobile || UserData.phone || "",
          UserFirstName: firstName,
          UserLastName: lastName,
          UserName: `${firstName} ${lastName}`.trim(),
        });
      }
      // Fallback: try to read from localStorage if Redux is empty (e.g., after page refresh)
      else {
        const storedUser = JSON.parse(localStorage.getItem("catalystUser"));
        if (storedUser) {
          setUser({
            userId: storedUser.userId || "",
            UserEmail: storedUser.email || "",
            UserMobile: storedUser.mobile || storedUser.phone || "",
            UserFirstName: storedUser.firstName || "",
            UserLastName: storedUser.lastName || "",
            UserName: `${storedUser.firstName || ""} ${storedUser.lastName || ""}`.trim(),
          });
        }
      }
    } else {
      // If no Redux data, fallback to localStorage
      const storedUser = JSON.parse(localStorage.getItem("catalystUser"));
      if (storedUser) {
        setUser({
          userId: storedUser.userId || "",
          UserEmail: storedUser.email || "",
          UserMobile: storedUser.mobile || storedUser.phone || "",
          UserFirstName: storedUser.firstName || "",
          UserLastName: storedUser.lastName || "",
          UserName: `${storedUser.firstName || ""} ${storedUser.lastName || ""}`.trim(),
        });
      }
    }
  }, [UserData]);

  return (
    <div className="">
      <div className="w-full md:pl-4 md:mt-0 lg:py-[10px] md:py-[10px] sm:py-0 ">
        <h1 className="lg:text-[40px] md:text-3xl text-3xl lg:mt-0 md:mt-0 mt-[-20px] text-center font-bold text-blue-900 mb-2">
          Account Details
        </h1>
        <hr className="heading-seperator border-4 border-blue-900" />

        {/* View Order Table */}
        <div className="w-full border lg:p-5 md:p-5 p-4 rounded-xl shadow-md">
          <form className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="first-name">
                First name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                id="first-name"
                type="text"
                value={user.UserFirstName}
                disabled
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="last-name">
                Last name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                id="last-name"
                type="text"
                value={user.UserLastName}
                disabled
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="display-name">
                Display name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                id="display-name"
                type="text"
                value={user.UserName}
                disabled
              />
              <p className="text-gray-600 text-xs italic mt-2">
                This will be how your name will be displayed in the account
                section and in reviews
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="email-address">
                Email address <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                id="email-address"
                type="email"
                value={user.UserEmail}
                disabled
              />
            </div>
            {/* Phone field remains commented as per original UI */}
          </form>
        </div>
      </div>
    </div>
  );
}